import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CoreCommonModule } from '@core/common.module';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { AuthLoginComponent } from './auth-login/auth-login.component';
import { AuthRequestAccessFileComponent } from './auth-request-access-file/auth-request-access-file.component';

// routing
const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/authentication/login',
  },
  {
    path: 'authentication/login',
    component: AuthLoginComponent,
    data: { animation: 'aLogin' },
  },
  {
    path: 'authentication/request-access-file',
    component: AuthRequestAccessFileComponent,
    data: { animation: 'aRequestAccessFile' },
  },
];

@NgModule({
  declarations: [AuthLoginComponent, AuthRequestAccessFileComponent],
  imports: [CommonModule, RouterModule.forChild(routes), NgbModule, CoreCommonModule, SweetAlert2Module.forRoot()],
  exports: [RouterModule],
})
export class AuthenticationModule {}
